import {Component, Input, OnInit} from '@angular/core';
import {BaseComponent, LeModalService, UsersQuery, TableComponent} from "common-shared";
import {DraftService, DraftToFinal} from "../draft.service";
import {debounceTime, takeUntil} from "rxjs/operators";
import {BehaviorSubject, Observable} from "rxjs";
import {ItemGroupsQuery, ItemsQuery} from "web-shared";
import {ManufacturingItemEditModalComponent} from "../../manufacturing-item/manufacturing-item-edit-modal/manufacturing-item-edit-modal.component";
import {ManufacturingItemGroupEditModalComponent} from "../../manufactured-item-groups/manufacturing-item-group-edit-modal/manufacturing-item-group-edit-modal.component";
import {TableCheckbox} from "primeng/table";

@Component({
  selector: 'app-item-group-drafts-overview',
  templateUrl: './item-group-drafts-overview.component.html',
  styles: []
})
export class ItemGroupDraftsOverviewComponent extends TableComponent implements OnInit {
  drafts$: Observable<DraftToFinal[]>;
  modifiedBy: string;
  selectedGroups: DraftToFinal[] = [];
  expandedKeys: { [s: string]: boolean; } = {undefined: true};

  constructor(private draftService: DraftService, public usersQuery: UsersQuery, public modalService: LeModalService, public itemGroupsQuery: ItemGroupsQuery, public itemsQuery: ItemsQuery) {
    super();
  }

  ngOnInit(): void {
    this.search$ = new BehaviorSubject<string>(null);
    this.search$.pipe(takeUntil(this.componentDestroyed), debounceTime(400)).subscribe(search => {
      this.getDraftsToFinal();
    });
  }

  getDraftsToFinal() {
    const search = this.search$.getValue();
    this.drafts$ = this.draftService.getDrafts(this.modifiedBy, search);
  }

  openItem(id: string) {
    this.modalService.show(ManufacturingItemEditModalComponent, {initialState: {entityId: id} as ManufacturingItemEditModalComponent, class: 'modal-xl'});
  }

  openItemGroup(id: string) {
    this.modalService.show(ManufacturingItemGroupEditModalComponent, {initialState: {entityId: id} as ManufacturingItemGroupEditModalComponent, class: 'modal-xl'});
  }

  changeSelection(tableCheckBox: TableCheckbox, event: MouseEvent) {
    if(this.table){
      const isChecked = !!tableCheckBox.checked;
      if (event.button === 0 && event.shiftKey) {
        if (isChecked) {
          this.table.selectRange(event, tableCheckBox.index);
        } else {
          this.table.rangeRowIndex = tableCheckBox.index;
          this.table.clearSelectionRange(event);
          this.table.tableService.onSelectionChange();
        }
      }
      this.table.anchorRowIndex = tableCheckBox.index;
    }
  }

  getRow = (row: any) => (row as DraftToFinal);

  publishSelection() {
    if(this.selectedGroups?.length){
      this.draftService.publishByGroups(this.selectedGroups).pipe(takeUntil(this.componentDestroyed)).subscribe(value1 => {
        console.log(value1);
      });
    }
  }
}
